// We want to call this generic Radio so we need a named default import for the MUI Radio it uses.
// eslint-disable-next-line import/no-named-default
import { default as MUIRadio } from '@mui/material/Radio';
import * as _ from 'lodash';
import type { ChangeEvent, VoidFunctionComponent } from 'react';

import css from './Radio.module.less';

type RadioProps = {
  id?: string;
  value: string;
  isChecked?: boolean; // Made optional since RadioGroup can manage this
  isDisabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
  testId?: string;
  /**
   * If the MUI ripples should be disabled or not
   */
  isRippleDisabled?: boolean;
  shouldStopPropagation?: boolean;
};

/**
 * Wrapper for MaterialUI's <Radio />
 * More aligned with the old Radio component API
 * Works automatically inside RadioGroups (like MUI Radio) or can use explicit isChecked for standalone use
 */
const Radio: VoidFunctionComponent<RadioProps> = ({
  id,
  value,
  isChecked,
  isDisabled,
  onChange = _.noop,
  testId,
  isRippleDisabled,
  shouldStopPropagation,
}) => {
  return (
    <MUIRadio
      id={id}
      value={value}
      // Only set checked if isChecked is explicitly provided
      // Otherwise let RadioGroup manage it automatically
      checked={isChecked !== undefined ? isChecked : undefined}
      onClick={(event) => {
        if (shouldStopPropagation) {
          event.stopPropagation();
        }
      }}
      onChange={onChange}
      data-test-id={testId}
      color="primary"
      disableRipple={isRippleDisabled}
      disableFocusRipple={isRippleDisabled}
      disableTouchRipple={isRippleDisabled}
      disabled={!!isDisabled}
      className={css.radio}
    />
  );
};

export default Radio;
